import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { NavLink } from 'o2web-react-core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Actions
import actions from '../../../actions/footer';

// Component
import CustomLink from '../../tools/customLink/CustomLink';

// Styles
import './styles.scss';

// images
import logo from '../../../../assets/images/mnbaq-original-logo.png';

// Props and Context
const propTypes = {
  location: PropTypes.object.isRequired,
  getFooter: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  nav: PropTypes.array.isRequired,
};
const defaultProps = {};
const contextTypes = {
  customStore: PropTypes.object,
  t: PropTypes.func,
};

// functions
const scrollToTop = (e) => {
  e.preventDefault();
  if (window) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

class Footer extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    this.state = { language: /\/fr/.test(location.pathname) ? 'fr' : 'en', offset: false };

    this.scrollTopButton = React.createRef();
  }

  componentDidMount() {
    const { getFooter } = this.props;
    const { customStore } = this.context;
    getFooter(customStore);
  }

  render() {
    const { language, offset } = this.state;
    const {
      text,
      nav,
    } = this.props;
    const { t } = this.context;

    if (window) {
      window.onscroll = () => {
        this.setState({ offset: window.pageYOffset > 500 });
      };
    }

    return (
      <footer className="footer">
        <div className="footer__wrapper">
          <div className="footer__logo">
            <NavLink to={`/${language}`}>
              <img src={logo} alt={t('pages.home.title')} />
            </NavLink>
          </div>
          <div className="footer__nav">
            { nav &&
            <ul className="footer__main-links">
              {nav.map((navItem) =>
                <li key={`nav_item_${navItem.path}`}>
                  <CustomLink path={navItem.path} lang={navItem.lang} title={navItem.text} className="footer__main-link link">
                    {navItem.title}
                  </CustomLink>
                </li>,
              )}
            </ul>
            }
            <a
              href={`https://www.mnbaq.org/${language}`}
              className="footer__mnbaq-link link"
              title="mnbaq.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              mnbaq.org
            </a>
          </div>
          <div className="footer__description">
            {text &&
              <div dangerouslySetInnerHTML={{ __html: text }} />
            }
          </div>
        </div>
        <button
          ref={this.scrollTopButton}
          className={classnames('footer__back-to-top button button--fill-light', { 'footer__back-to-top--displayed': offset })}
          onClick={scrollToTop}
        >
          <span className="footer__back-to-top__content">{t('footer.backToTop')}</span>
          <span className="footer__back-to-top__icon" />
        </button>
      </footer>
    );
  }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
Footer.contextTypes = contextTypes;

function mapStateToProps(state) {
  return {
    text: state.footer.text,
    nav: state.footer.nav,
  };
}

export default withRouter(connect(mapStateToProps, actions)(Footer));



// WEBPACK FOOTER //
// ./src/app/components/layouts/footer/Footer.js